import { render, staticRenderFns } from "./testimonial.vue?vue&type=template&id=7fc5893d"
import script from "./testimonial.vue?vue&type=script&lang=js"
export * from "./testimonial.vue?vue&type=script&lang=js"
import style0 from "./testimonial.vue?vue&type=style&index=0&id=7fc5893d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports